
export enum TrapReasonCd {
	CLOSED_FOR_HOLIDAY = 'ClosedForHoliday',
	CUSTOMER_REQUEST_CONSOLIDATE = 'CustomerRequestConsolidate',
	HELD_PROTECTIVE_SERVICE = 'HeldProtectiveService',
	RECEIVE_TIME_RESTRICTED = 'ReceiveTimeRestricted'}

